// imports
import { Address } from 'abitype';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { RootState } from '../..';
import { msgFromError } from '../../utils';
import { TEXTS } from '../../../../constants';
import { WLWalletDelegation } from '../../../web3';
import { setDelegateWallet, getDelegateWallet } from '../../../localStorage';

// exports
export const fetchDelegateWallet = createAsyncThunk(
  'user/delegateWallet/fetch',
  (_, { getState, rejectWithValue }) => {
    const wallet = (getState() as RootState).user.id as Address;
    return getDelegateWallet(wallet).catch((error) => rejectWithValue(msgFromError(error, TEXTS.ERROR_FETCH_DELEGATE_WALLET)));
  },
  {
    condition: (_, { getState }) => {
      const { delegateWallet } = (getState() as RootState).user;
      return delegateWallet.fetchStatus !== 'loading';
    }
  }
);
export const updateDelegateWallet = createAsyncThunk(
  'user/delegateWallet/update',
  (_, { getState, rejectWithValue }) => {
    const wallet = (getState() as RootState).user.id as Address;
    return WLWalletDelegation.addDelegateWallet()
      .then((delegateWallet) => setDelegateWallet(wallet, delegateWallet))
      .catch((error) => rejectWithValue(msgFromError(error, TEXTS.ERROR_REGISTER_DELEGATE_WALLET)));
  },
  {
    condition: (_, { getState }) => {
      const { delegateWallet } = (getState() as RootState).user;
      return delegateWallet.updateStatus !== 'loading';
    }
  }
);
export const resetDelegateWallet = createAsyncThunk(
  'user/delegateWallet/reset',
  (_, { getState, rejectWithValue }) => {
    const wallet = (getState() as RootState).user.id as Address;
    return setDelegateWallet(wallet, null).catch((error) => rejectWithValue(msgFromError(error, TEXTS.ERROR_REGISTER_DELEGATE_WALLET)));
  },
  {
    condition: (_, { getState }) => {
      const { delegateWallet } = (getState() as RootState).user;
      return delegateWallet.updateStatus !== 'loading';
    }
  }
);

export default { fetchDelegateWallet, updateDelegateWallet, resetDelegateWallet };
